import { motion } from "framer-motion";
import { container, itemUp } from "../Utils/framerMotionVariants";
import { projects } from "../data/projects";
import ProjectCard from "./ProjectCard";

const Projects: React.FC = () => {
  return (
    <section id="projects" className="mt-20 scroll-mt-28">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
      >
        <motion.h2
          variants={itemUp}
          className="text-2xl font-semibold text-cyan-700"
        >
          Projects
        </motion.h2>
        <div className="mt-6 grid md:grid-cols-2 gap-6">
          {projects.map((p, i) => (
            <ProjectCard project={p} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Projects;
